import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';
import globalReducers from '@americanexpress/one-app-ducks';
import { actionTypes } from '@americanexpress/amex-connect-core';

export const UPDATE_SPLUNK_TOKEN = 'modules/amex-connect-root/UPDATE_SPLUNK_TOKEN';

export const initialState = fromJS({
  connect: {
    partner: '',
    source: '',
    accounts: [],
    selectedAccount: '',
    isAccountsLoaded: false,
    isAccountFixed: false,
    isCardOnFileStarted: false,
    isLoading: false,
    currentFlow: 'select',
    isInstant: false,
    token: null,
    splunkToken: null,
    hasUserCancelled: false,
    isOtpValid: true,
    isMaxOtpReached: false,
    isCidValid: true,
    isAuthenticated: false,
  },
  window: {
    innerHeight: 0,
    innerWidth: 0,
  },
});

// when passing an object as payload make sure its an immutable object
export function rootReducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case actionTypes.MERGE_VALUES:
      return state.mergeIn(['connect'], payload);
    case actionTypes.SELECT_ACCOUNT:
      return state.setIn(['connect', 'selectedAccount'], payload);
    case actionTypes.SET_ACCOUNT_FIXED:
      return state.setIn(['connect', 'isAccountFixed'], payload);
    case actionTypes.SET_ACCOUNTS_LOADED:
      return state.setIn(['connect', 'isAccountsLoaded'], payload);
    case actionTypes.SET_CARD_ON_FILE_STARTED:
      return state.setIn(['connect', 'isCardOnFileStarted'], payload);
    case actionTypes.SET_CID_VALID:
      return state.setIn(['connect', 'isCidValid'], payload);
    case actionTypes.SET_CURRENT_FLOW:
      return state.setIn(['connect', 'currentFlow'], payload);
    case actionTypes.SET_LOADING:
      return state.setIn(['connect', 'isLoading'], payload);
    case actionTypes.SET_MAX_OTP_REACHED:
      return state.setIn(['connect', 'isMaxOtpReached'], payload);
    case actionTypes.SET_OTP_VALID:
      return state.setIn(['connect', 'isOtpValid'], payload);
    case actionTypes.SET_USER_CANCELLED:
      return state.setIn(['connect', 'hasUserCancelled'], payload);
    case actionTypes.SET_WINDOW_SIZE:
      return state.mergeIn(['window'], fromJS({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      }));
    case actionTypes.UPDATE_ACCOUNTS:
      return state.setIn(['connect', 'accounts'], payload);
    case actionTypes.UPDATE_CORRELATION_ID:
      return state.setIn(['connect', 'correlationId'], payload);
    case actionTypes.UPDATE_ERROR:
      return state.setIn(['connect', 'error'], payload);
    case actionTypes.UPDATE_PARTNER:
      return state.setIn(['connect', 'partner'], payload);
    case actionTypes.UPDATE_SOURCE:
      return state.setIn(['connect', 'source'], payload);
    case actionTypes.UPDATE_IM_FLAG:
      return state.setIn(['connect', 'isInstant'], payload);
    case actionTypes.UPDATE_AUTH_TOKEN:
      return state.setIn(['connect', 'token'], payload);
    case UPDATE_SPLUNK_TOKEN:
      return state.setIn(['connect', 'splunkToken'], payload);
    case actionTypes.UPDATE_PROVISION_ID:
      return state.setIn(['connect', 'provisionId'], payload);
    default:
      return state;
  }
}

export const reducer = combineReducers({
  ...globalReducers,
  rootReducer,
});

export default reducer;
